import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import LoadingButton from "@mui/lab/LoadingButton"
import Grow from "@mui/material/Grow"
import CircularProgress from "@mui/material/CircularProgress"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"

export default withTranslation()(
  class RenameExperienceDialog extends Component {
    state = { name: null, nameEmpty: null, nameError: null, loading: false }

    componentWillReceiveProps(nextProps) {
      if (nextProps.open && !this.props.open) {
        this.setState({
          name: null,
          nameEmpty: null,
          nameError: null,
          loading: false,
        })
      }
    }

    renameExperience = async (experience, name) => {
      const { close, setExperiences, experiences, t } = this.props

      this.setState({ loading: true })

      await fetch(
        `${
          process.env.REACT_APP_SERVER_URL
        }/experiences/${experience}?password=${localStorage.getItem(
          "password"
        )}&name=${name}`,
        {
          method: "PUT",
          headers: {},
        }
      )
        .then(() => {
          close()

          setExperiences([
            ...experiences.filter(({ _id }) => _id !== experience),
            { ...experiences.find(({ _id }) => _id === experience), name },
          ])
        })
        .catch(() => this.setState({ nameError: t`Something went wrong` }))
        .finally(() => this.setState({ loading: false }))
    }

    render() {
      const { open, close, t, name: currentName } = this.props
      const { name, nameEmpty, nameError, loading } = this.state

      return (
        <Dialog
          open={open}
          onClose={close}
          TransitionComponent={Grow}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            className="notSelectable"
            style={{ fontWeight: 600 }}
          >{t`Rename experience`}</DialogTitle>
          <DialogContent style={{ paddingBottom: 0 }}>
            <DialogContentText>
              <TextField
                defaultValue={currentName}
                fullWidth
                label={t`Experience name`}
                variant="outlined"
                style={{ textTransform: "none" }}
                margin="normal"
                value={name}
                error={nameEmpty || nameError}
                helperText={
                  nameEmpty ? t`This field is required` : nameError || " "
                }
                onKeyPress={(event) => {
                  if (event.key === "Enter" && name && !nameError) {
                    this.renameExperience(
                      queryStringify.parse(window.location.search).experience,
                      name
                    )
                  }
                }}
                onChange={(event) =>
                  this.setState({
                    name: event.target.value,
                    nameEmpty: event.target.value.replace(/\s/g, "") === "",
                    nameError: "",
                  })
                }
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={close}>{t`Close`}</Button>
            <LoadingButton
              loading={loading}
              loadingIndicator={<CircularProgress size={16} />}
              color="primary"
              style={{ fontWeight: 600 }}
              disabled={!name || nameError}
              onClick={() =>
                this.renameExperience(
                  queryStringify.parse(window.location.search).experience,
                  name
                )
              }
            >{t`Rename`}</LoadingButton>
          </DialogActions>
        </Dialog>
      )
    }
  }
)
